/**
 * 激活打卡抽奖活动
 */

/* 查询奖品列表 */
export const PRIZE_LIST = '/xlm-app/activeClockIn/queryPrizeList';

/* 查询用户剩余抽奖次数 */
export const DRAW_NUM = '/xlm-app/activeClockIn/queryDrawNum';

/* 查询当前周达标记录 */
export const WEEK_RECORD = '/xlm-app/activeClockIn/queryCurrentWeekRecord';

/* 分享今日打卡 */
export const SHARE_CLOCK_TODAY = '/xlm-app/activeClockIn/shareClockToday';

/* 查询本月每周达标记录 */
export const MONTH_ALL_WEEK_RECORD = '/xlm-app/activeClockIn/queryWeekCompleteDetails';

/* 查询当日是否已提示打卡 */
export const COMPLETED_TYPE = '/xlm-app/activeClockIn/queryCompletedType';

/* 抽奖 */
export const LUCK_DRAW = '/xlm-app/activeClockIn/luckDraw';

/* 查询奖励明细 */
export const REWARD_LIST = '/xlm-app/activeClockIn/queryRewardDetails';

//报名接口
export const SIGN_UP = '/xlm-refactor/event/eventCommon/signup';

// 查询报名状态
export const SIGNUP_STATUS = '/xlm-refactor/event/eventCommon/querySignupStatus';

/* 集火英雄榜 */
export const HERO_RANKING = '/xlm/studioGroupActivities/getFireHeroRanking';

/* 集火令牌排行榜 */
export const TOKEN_RANKING = '/xlm/studioGroupActivities/getFireTokenRanking';

// 暖阳计划  查询补偿
export const FIND_BYUSERID = '/xlm-app/salesManCompensation/findByUserId';

// 暖阳计划  查询是否有补偿计划
export const HAS_COMPENSATION = '/xlm-app/salesManCompensation/hasCompensation';

// 暖阳计划  领取优惠券
export const RECEIVE_COUPON = '/xlm-app/salesManCompensation/receiveCoupon';

// 暖阳计划  领取礼包
export const RECEIVE_GIFT = '/xlm-app/salesManCompensation/receiveGift';

//个人挑战赛
export const DEVICE_ACTIVITY_RANKING =
  '/xlm-activity/deviceActivity/deviceActivityApp/getDeviceActivityRanking';

//查询本月达标情况
export const ACHIEVE_INFO = '/xlm-data/salesActiveAchieveQuery/getAchieveInfo';

//查询每月激活详情
export const ACTIVE_DETAIL = '/xlm-data/salesActiveAchieveQuery/getActiveDetail';

//激活突破挑战赛-排行榜
export const CHALLENGE_RANKING = '/xlm-app/activeChallenge/getActiveChallengeRanking';

//激活突破挑战赛-是否可以抽奖
export const JUDGE_CANDRAW = '/xlm-app/activeChallenge/judgeWhetherCanDraw';

//激活突破挑战赛-抽奖
export const DO_DRAW = '/xlm-app/activeChallenge/doDraw';

//激活突破挑战赛-抽奖结果
export const GET_DRAWRESULT = '/xlm-app/activeChallenge/getDrawResult';

//超级星探挑战赛-邀约人数
export const VALID_INVITATION =
  '/xlm-activity/superStarActivity/superStarActivityApp/validInvitation';

//超级星探挑战赛-弹窗
export const SUPER_STAR_TIP = '/xlm-app/superStarActivity/tip';

//红蓝挑战赛-校验管家是否是工作室负责人
export const CHECK_LEADER = '/xlm-app/activity/checkOfficeLeader';

//红蓝挑战赛-查询地面销售活动列表
export const GET_ACTIVITY_LIST = '/xlm-app/activity/getActivityGroundSalesHomeList';

//红蓝挑战赛-查询活动封面
export const GET_ACTIVITY_COVER = '/xlm-app/activity/getActivityGroundSalesCovers';

//红蓝挑战赛-创建地面销售活动
export const CREATE_ACTIVITY = '/xlm-app/activity/createActivityGroundSales';

//红蓝挑战赛-加入地面销售活动
export const JOIN_ACTIVITY = '/xlm-app/activity/joinActivityGroundSales';

//红蓝挑战赛-查询地面销售活动详情
export const GET_ACTIVITY_DETAIL = '/xlm-app/activity/getActivityGroundSalesDetail';

//红蓝挑战赛-增加火力值
export const ADD_VALUE = 'xlm-app/activity/addFirePowerValue';

//红蓝挑战赛-查询活动列表
export const GET_ACTIVITY_TYPE = 'xlm-app/activity/getActivityGroundSalesType';

//红蓝挑战赛-查询寻找中活动场次
export const GET_FINDING_ACTIVE_NUM = 'xlm-app/activity/countFindingOpponent';

//红蓝挑战赛-查询地面销售活动天梯榜单列表
export const GET_ACTIVITY_RANK_LIST = 'xlm-app/activity/getActivityGroundSalesRankList';

//直升v7查询接口
export const GET_EFFECT_GRADE = 'xlm-data/salesActiveAchieveQuery/getEffectGrade';

//查询地面销售活动战报
export const GROUND_SALES_YESTERDAY_REPORT =
  '/xlm-app/activity/getActivityGroundSalesYesterdayReport';

// 查询用户角色
export const GET_USER_IDENTITY = 'xlm-app/activity/getUserIdentity';

// 奖金池首页展示
export const FIND_ALLY_REWARD_POOL_HOME = 'xlm-data/rewardPoolQuery/findAllyRewardPoolHome';
export const FIND_ALLY_REWARD_POOL_HOME2424 =
  'xlm-data/rewardPoolQuery/findAllyRewardPoolHomeFor2024';

export const FIND_ALLY_REWARD_POOL_HOME2525 =
  'xlm-data/rewardPoolQuery/findAllyRewardPoolHomeFor2025';

// 管家每月瓜分记录
export const FIND_ALLY_REWARD_RECORD = 'xlm-data/rewardPoolQuery/findAllyRewardRecord';

// 查询横排激励活动-信息
export const GET_FIND_PFT_SUB = 'xlm-data/rewardPoolQuery/findPftSub';

// 查询横排激励活动-信息明细
export const GET_FIND_PFT_SUB_DETAIL = 'xlm-data/rewardPoolQuery/findPftSubDetail';

// 奖金池首页展示-查询等级信息
export const FIND_MY_REWARD_POOL_LV = 'xlm-data/rewardPoolQuery/findMyRewardPoolLv';

// 24年端午-抽奖
export const DRAW_PRIZE = '/xlm-activity/activityPrize/drawPrize';

// 24年端午-转发
export const FORWARD = '/xlm-activity/activityPrize/forward';

// 24年端午-激活列表
export const GET_ACTIVE_LIST = '/xlm-activity/activityPrize/getActiveList';

// 24年端午-获取领奖分公司
export const GET_CHOOSE_COMPANY = '/xlm-activity/activityPrize/getChooseCompany';

// 24年端午-选择领奖分公司
export const CHOOSE_COMPANY = '/xlm-activity/activityPrize/chooseCompany';

// 24年端午-奖品id列表
export const GET_PRIZE_ID_LIST = '/xlm-activity/activityPrize/getPrizeIdList';

// 查询是否获得新人办卡奖励(true:已获得;false:未获得)
export const CHECK_OBTAIN_REWARD = '/xlm-activity/newPeopleApplyCard/checkObtainReward';

// 查询工作室负责人T队办卡首页
export const GET_OFFICE_TEAM_APPLY_CARD_HOME_PAGE =
  '/xlm-activity/officeTeamApplyCard/getOfficeTeamApplyCardHomePage';

// 查询历史办卡奖励(月维度汇总)
export const GET_HISTORY_APPLY_CARD_SUMMARY =
  '/xlm-activity/officeTeamApplyCard/getHistoryApplyCardSummary';

// 查询当月办卡奖励明细
export const GET_CURRENT_MONTH_APPLY_CARD_DETAIL =
  '/xlm-activity/officeTeamApplyCard/getCurrentMonthApplyCardDetail';

// 活动广场查询活动列表
export const ACTIVEITY_SQUARE_GET_ACTIVITY_LIST = '/xlm-activity/activitySquare/getActivityList';

// 工作室培养快速V3奖励-获取奖励信息
export const GET_REWARD_INFO = '/xlm-data/officeMemberUpV3/getRewardInfo';

// 工作室培养快速V3奖励-v3列表
export const GET_REWARD_V3_LIST = '/xlm-data/officeMemberUpV3/getRewardV3List';

// 工作室激活奖励-查询工作室上月激活数和激活奖励
export const GET_OFFICE_ACTIVE_REWARD_OF_LAST_MONTH =
  '/xlm-activity/officeActiveReachSupport/getOfficeActiveRewardOfLastMonth';

// 工作室激活奖励-查询工作室上月激活数和激活奖励
export const GET_OFFICE_ACTIVE_REWARD_OF_HISTORY =
  '/xlm-activity/officeActiveReachSupport/getOfficeActiveRewardOfHistory';

// v3-v5-交易加码 查看本月核算等级
export const V3_V5_TRADE_PLUS_GET_LV = '/xlm-data/v3v5TradePlus/getLv';

// v3-v5-交易加码 月度分红加码交易
export const V3_V5_TRADE_PLUS_GET_MONTH_REWARD_PLUS_INFO =
  '/xlm-data/v3v5TradePlus/getRewardPlusInfo';

// v3-v5-交易加码 查看月度分红加码交易本月数据
export const V3_V5_TRADE_PLUS_GET_THIS_MONTH_INFO = '/xlm-data/v3v5TradePlus/getThisMonthInfo';

// 查询梯队有效管家列表
export const REWARD_POOL_QUERY_GET_SALESMAN_NUM_OVER_3 =
  '/xlm-data/rewardPoolQuery/queryFollowUpUsers';

// 查看月度分红加码交易有效用户
export const V3_V5_TRADE_PLUS_GET_EFFECTIVE_USERS = '/xlm-data/v3v5TradePlus/getEffectiveUsers';

// 工作室培养快速V3奖励-可跟进管家名单
export const GET_REWARD_V2_LIST = '/xlm-data/officeMemberUpV3/getRewardV2List';

// 招财伯乐奖励-查询我的排名列表
export const Find_MY_RANK_LIST = '/xlm-data/rewardPoolQuery/findMyRankList';

// 招财伯乐奖励-查询历史奖励记录
export const GET_HISTORICAL_REWARD_LIST = '/xlm-data/extInvPromAct/getHistoricalRewardList';

// 招财伯乐奖励-校验管家是否可以参与活动
export const CHECK_USER_IF_CAN_PART_ACT = '/xlm-data/extInvPromAct/checkUserIfCanPartAct';

// 招财伯乐奖励-查询本月奖励记录
export const GET_MONTHLY_REWARD_LIST = '/xlm-data/extInvPromAct/getMonthlyRewardList';

// 招财伯乐奖励-查询本月预估总奖励金额
export const GET_MONTHLY_TOTAL_EST_REWARD_AMT =
  '/xlm-data/extInvPromAct/getMonthlyTotalEstRewardAmt';

// 获取服务器当前时间
export const FIND_VALUE = '/xlm-app/commonConfig/find-value';

// 25年签包活动
export const GET_LOGIN_USER_SIGN_ACTIVITY_LIST =
  '/xlm-app/signActivity/getLoginUserSignActivityList?year=2025';

// 十周年活动-查询纪念币统计
export const TEN_YEARS_GET_COIN_STATS = '/xlm-app/tenYears/getCoinStats';

// 十周年活动-查询纪念币排行榜
export const TEN_YEARS_GET_COIN_RANK_LIST = '/xlm-app/tenYears/getCoinRankList';

// 双薪计划接口
export const GET_DOUBLE_SALARY_REWARD_ACTIVITY =
  '/xlm-data/rewardPoolQuery/getDoubleSalaryRewardActivity';

// 双薪计划上月达标奖励
export const GET_DOUBLE_SALARY_REWARD_ACTIVITY_LAST_MONTH =
  '/xlm-data/rewardPoolQuery/getDoubleSalaryRewardActivityLastMonth';

// 双薪计划横排管家列表
export const GET_DOUBLE_SALARY_REWARD_BY_P_USER_ID =
  '/xlm-data/rewardPoolQuery/getDoubleSalaryRewardByPUserId';
